import { createSlice } from "@reduxjs/toolkit";
import { InstallmentConditionsAPI } from "../../services/installment-conditions";

const InstallmentConditions = createSlice({
  name: "installmentConditions",
  initialState: {
    list: [],
    oneInstallmentCondition: null,
    total: 0,
  },
  reducers: {
    clearOneInstallmentCondition: (state) => {
      state.oneInstallmentCondition = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(InstallmentConditionsAPI.getAll.fulfilled, (state, action) => {
        const { total, installment_conditions } = action.payload;
        state.list = installment_conditions;
        state.total = total;
      })
      .addCase(InstallmentConditionsAPI.getOne.fulfilled, (state, action) => {
        state.oneInstallmentCondition = action.payload;
      });
  },
});

export const { clearOneInstallmentCondition } = InstallmentConditions.actions;
export default InstallmentConditions;
